import { Component, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

export enum HandleType {
  TOP = 'TOP',
  BOTTOM = 'BOTTOM',
}

@Component({
  selector: 'selection-area',
  templateUrl: 'selection-area.html',
  standalone: false
})
export class SelectionAreaComponent implements OnInit, OnChanges {
  @Input() top;
  @Input() left;
  @Input() width;
  @Input() height;
  @Input() mouseMove;
  @Input() activeHandle;
  @Input() url;
  @Output() onUpdate = new EventEmitter();
  @Output() onDelete = new EventEmitter();
  draggedHandle: HandleType;
  rightBottomX: number;
  rightBottomY: number;
  leftTopX: number;
  leftTopY: number;
  style;
  editingUrl = false;

  ngOnInit() {
    this.mouseMove.subscribe((e) => this.onMouseMove(e));
    this.onSizeInputsChanged();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['top'] || changes['left'] || changes['width'] || changes['height']) {
      this.onSizeInputsChanged();
    }
  }

  onMouseMove(event) {
    if (this.activeHandle !== undefined) {
      this.draggedHandle = this.activeHandle;
    }
    if (this.draggedHandle === HandleType.TOP) {
      if (event.x < this.rightBottomX) {
        this.leftTopX = event.x;
      }
      if (event.y < this.rightBottomY) {
        this.leftTopY = event.y;
      }
    }
    if (this.draggedHandle === HandleType.BOTTOM) {
      if (event.x > this.leftTopX) {
        this.rightBottomX = event.x;
      }
      if (event.y > this.leftTopY) {
        this.rightBottomY = event.y;
      }
    }
    if (this.draggedHandle !== undefined) {
      this.updateStyle();
    }
  }

  onHandlePressed(event: MouseEvent, handleType: HandleType) {
    event.preventDefault();
    event.stopPropagation();
    this.draggedHandle = handleType;
  }

  onTopHandlePressed(event: MouseEvent) {
    this.onHandlePressed(event, HandleType.TOP);
  }

  onBottomHandlePressed(event: MouseEvent) {
    this.onHandlePressed(event, HandleType.BOTTOM);
  }

  @HostListener('window:mouseup', ['$event'])
  onMouseUp(event: any) {
    event.preventDefault();
    if (this.draggedHandle) {
      this.notifyClickAreaChanged();
    }
    this.draggedHandle = undefined;
  }

  notifyClickAreaChanged() {
    const rectangleDefinition = {
      top: this.leftTopY,
      left: this.leftTopX,
      width: this.rightBottomX - this.leftTopX,
      height: this.rightBottomY - this.leftTopY,
    };
    const clickAreaDefinition = { rectangleDefinition, url: this.url };
    this.onUpdate.emit(clickAreaDefinition);
  }

  updateStyle() {
    this.style = {
      top: this.leftTopY + 'px',
      left: this.leftTopX + 'px',
      width: this.rightBottomX - this.leftTopX + 'px',
      height: this.rightBottomY - this.leftTopY + 'px',
    };
  }

  updateCoordinatesFromInputs() {
    this.leftTopX = this.left;
    this.leftTopY = this.top;
    this.rightBottomX = this.leftTopX + this.width;
    this.rightBottomY = this.leftTopY + this.height;
  }

  onSizeInputsChanged() {
    this.updateCoordinatesFromInputs();
    this.updateStyle();
  }

  onDeleteButtonClick(event: MouseEvent) {
    event.preventDefault();
    this.onDelete.emit();
  }

  saveUrl(event) {
    event.stopPropagation();
    this.editingUrl = false;
    this.notifyClickAreaChanged();
  }
}
